import { ServerEnv } from 'Configs/ServerEnv'
import StoreLoader from 'GlobalStores/Cores/Elements/StoreLoader'
import { runInAction } from 'mobx'
import { useState, useEffect, useRef } from 'react'
import StoreCountry from '../../../GlobalStores/Cores/County/StoreCountry'
import { PathHelper } from 'GlobalStores/Cores/Helpers/PathHelper'
import BypassRedirectPath from '../../../Data/BypassRedirectPath.json'
import { proxiedGet } from 'Services/apiClient'

export function useCountries() {
    const once = useRef(true)
    const [country, setCountry] = useState()
    const qs = new URL(window.location.href)

    useEffect(() => {
        if (once.current) {
            once.current = false
            GetCountries()
        }
        return () => {
            once.current = false
        }
    }, [])

    useEffect(() => {
        if (country) {
            document.title = `Feel Great (${country.shorter})`
            runInAction(() => {
                StoreCountry.fetching = false
                StoreLoader.SetApiLoaded('country', true)
                StoreCountry.SetCountry(country)
            })
        }
    }, [country])

    const GetCountries = async () => {
        if (StoreCountry.data.length === 0) {
            const url = `https://${ServerEnv.MemberCalls2(true)}.unicity.com/settings/countryFeelGreatV2/enable`
            try {
                StoreCountry.fetching = true
                const response = await proxiedGet(url)
                runInAction(() => {
                    const countries = response.data.data
                    countries.middle_east.forEach(item => {
                        if (item.shorter === 'SA') {
                            item.country2 = 'Saudi'
                        }
                    })
                    StoreCountry.SetCountryList(countries)
                })

                const currentCountry = StoreCountry.CountryList().find(item => checkCountry(item))
                if (!/\/select-country/.test(window.location.pathname)) {
                    if (currentCountry) {
                        const mm = currentCountry.maintenance_mode
                        if (mm.maintenance_mode) {
                            if (/developing/.test(mm.text.english) || /developing/.test(mm.text.native)) {
                                if (/fg.unicity.com/.test(window.location.hostname)) {
                                    window.location.replace(`/select-country`)
                                }
                            }
                        }
                        if (currentCountry) {
                            setCountry(currentCountry)
                            return
                        }

                        if (!qs.searchParams.get('market')) {
                            const savedCountry = localStorage.getItem('currentCountry')
                            const countryCode = savedCountry || 'select-country'
                            window.location.replace(`/${countryCode}${window.location.pathname}${window.location.search}`)
                            return
                        }
                    } else {
                        if (!/\/select-country/.test(window.location.pathname)) {
                            if (!BypassRedirectPath.includes(PathHelper.Segment(1))) {
                                redirectCountry()
                            }
                        } else {
                            window.location.replace(PathHelper.BuildBasename('select-country'))
                        }
                    }
                }
            } catch (e) {
                console.error(e)
                StoreCountry.fetching = false
            }
        }
    }

    const redirectCountry = () => {
        const pathnames = window.location.pathname.split('/')
        let newUrl = ''

        if (/^\/feature/.test(window.location.pathname)) {
            newUrl = `${window.location.protocol}//${window.location.host}/${pathnames[1]}/${pathnames[2]}/${pathnames[3]}/select-country/${pathnames[5] || ''}`
        } else if (/^\/epic/.test(window.location.pathname)) {
            newUrl = `${window.location.protocol}//${window.location.host}/${pathnames[1]}/${pathnames[2]}/${pathnames[3]}/${pathnames[4]}/select-country/${pathnames[6] || ''}`
        } else {
            newUrl = `${window.location.protocol}//${window.location.host}/select-country${pathnames[2] ? `/${pathnames[2]}` : ''}`
        }

        newUrl += window.location.search

        window.location.replace(newUrl)
    }

    const checkCountry = item => {
        const countryPath = PathHelper.CountryFromPathname()

        if (countryPath.length === 0) {
            window.location.replace(PathHelper.BuildBasename('select-country'))
        }

        return [item.country, item.country2, item.short, item.shorter].some(path => (path || '').replace(/\s/g, '').toLowerCase() === countryPath.toLowerCase())
    }

    return country
}
